import React from "react";
import { HiOutlineMap } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import type { Column } from "../../../ui";
import { _TYPES_ } from "../utils/types";
import { pushOneCityGuide } from "../../../lib/sysNavigation/SysNavigation";

type CityGuideRow = {
  city_guide_id: number | string;
  title?: string;
  stcityguide_date?: string;
  [key: string]: unknown;
};

const extraColumns: Column<CityGuideRow>[] = [
  {
    header: "Start Date",
    cell: (row) => (
      <span className="text-gray-600">{row.stcityguide_date ?? "—"}</span>
    ),
  },
];

const Overview: React.FC = () => (
  <DoSeeListPage<CityGuideRow>
    type={_TYPES_.CITYGUIDE}
    title="City Guides"
    subtitle="Curated city guide entries for travellers."
    icon={<HiOutlineMap className="h-5 w-5" />}
    addRoute="/data/city/guide/add"
    editRoute="/data/city/guide/edit"
    pushOne={pushOneCityGuide}
    dataKey="cityGuides"
    countKey="cityGuidesCount"
    idField="city_guide_id"
    extraColumns={extraColumns}
  />
);

export default Overview;
